import React, { FC, useCallback, useMemo } from 'react'
import { Button, Tooltip, Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { TTableColumn } from 'shared/types'

import { ProductChartMatchTableData, TProductChartMatchTableProps } from './ProductChartMatchTable.props'
import styles from './ProductChartMatchTable.module.scss'

const ProductChartMatchTable: FC<TProductChartMatchTableProps> = ({ productChartMatchList, onConfirmProductChartMatch }) => {

  const confirmProductChartMatch = useCallback(
    (id) => () => {
      onConfirmProductChartMatch(id)
    },
    [onConfirmProductChartMatch]
  )

  const productChartMatchListRows: ProductChartMatchTableData[] = useMemo(
    () =>
      productChartMatchList.map((item) => {
        return {
          id: item.id,
          artistChartName: item.artist_chart_name,
          artistName: item.artist_name,
          configuration: item.configuration,
          productChartName: item.product_chart_name,
          productName: item.product_name,
        }
      }),
    [productChartMatchList]
  )

  const columns: ColumnsType<TTableColumn>[] = [
    {
      dataIndex: 'configuration',
      key: 'configuration',
      title: 'Configuration',
      sortable: false,
      width: 143,
      align: 'left'
    },
    {
      dataIndex: 'artistChartName',
      key: 'artistChartName',
      title: 'Artist Chart Name',
      sortable: false,
      width: 191,
      align: 'left'
    },
    {
      dataIndex: 'artistName',
      key: 'artistName',
      title: 'Artist Name',
      sortable: false,
      width: 287,
      align: 'left'
    },
    {
      dataIndex: 'productChartName',
      key: 'productChartName',
      title: 'Product Chart Name',
      sortable: false,
      width: 191,
      align: 'left'
    },
    {
      dataIndex: 'productName',
      key: 'productName',
      title: 'Product Name',
      sortable: false,
      width: 191,
      align: 'left'
    },    
    {
      dataIndex: '',
      key: 'confirm',
      title: 'Confirm',
      sortable: false,
      align: 'center',
      width: 54,
      render: (value: string, item: any) => (
        <Tooltip message="Confirm" colorType="dark">
          <Button
            className={styles.confirmBtn}
            containerStyle="link"
            onClick={confirmProductChartMatch(item.id)}
            icon="plus"
            colorType="secondary-black"
          />
        </Tooltip>
      )
    }
  ]

  return (
    <Table
      className={styles.container}
      columns={columns as any}
      rowKey={(record: any) => record.id}
      tableLayout="fixed"
      data={productChartMatchListRows}
      pagination={false}
    />
  )
}

export default ProductChartMatchTable
